// extracted by mini-css-extract-plugin
var _1 = "lxwmYUlHfaQcEcJB60g0";
export { _1 as "heading" }
